import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastService } from './toast.service';
import { Observable, catchError, map, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { IResponse } from '../shared/models/IResponse.model';
import { IASMModel } from '../shared/models/asm.model';

@Injectable({
  providedIn: 'root'
})
export class MvtService {

  constructor(private httpClient: HttpClient, private toastService: ToastService) { }

  uploadMvt(mvtData: IASMModel): Observable<boolean> {
    return this.httpClient.post(`${environment.api_base_url}mvt/upload`, mvtData, {}).pipe(
      map((item: IResponse<boolean>) => {
        if(item?.isError){
          console.log(item.message);
        }
        return item?.data || null;
      }),
      catchError(() => {
        this.toastService.showError("Error uploading MVT file");
        return of(null);
      })
    );
  }
}
